import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../../api/apiServises';
import {
  // FETCH_UF_FRAME_TYPES,
  FETCH_UF_STAGES,
  FETCH_UF_VISUAL_TYPES,
  FETCH_METAL_TYPES,
  ADD_UF_VISUAL_OBS,
  ADD_VISUAL_TYPES,
  UPDATE_VISUAL_TYPES,
  DELETE_VISUAL_TYPES,
  FETCH_USER,
  DELETE_USER,
  UPDATE_USER,
  FETCH_RITES_SUP_USER,
  FETCH_AIR_BRAKE_POINTS,
  FETCH_ALL_UF_FRAME_TYPES,
} from '../../../api/apiConstant';

// Fetch Under Frame Types
export const fetchUnderFrameType = createAsyncThunk(
  'frametype/fetchUnderFrameType',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_ALL_UF_FRAME_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const fetchAllUnderFrameType = createAsyncThunk(
  'frametype/fetchAllUnderFrameType',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_ALL_UF_FRAME_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Fetch Under Frame Stages
export const fetchUfStages = createAsyncThunk(
  'frametype/fetchUfStages',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_STAGES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Fetch Visual Types
export const fetchUfVisualTypes = createAsyncThunk(
  'frametype/fetchUfVisualTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_VISUAL_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Fetch Metal Types
export const fetchMetalTypes = createAsyncThunk(
  'frametype/fetchMetalTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_METAL_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

// Add UF Visual Observation
export const addUfVisualObs = createAsyncThunk(
  'frametype/addUfVisualObs',
  async (data, { rejectWithValue }) => {
    try {
      const payload = {
        collection_name: 'uf_visual_obs_params',
        ...data,
      };

      const response = await api.post(ADD_UF_VISUAL_OBS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to save visual observation',
      );
    }
  },
);
export const addVisualTypes = createAsyncThunk(
  'frametype/addVisualTypes',
  async (data, { rejectWithValue }) => {
    try {
      const response = await api.post(ADD_VISUAL_TYPES, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to save visual observation',
      );
    }
  },
);
export const updateVisualTypes = createAsyncThunk(
  'frametype/updateVisualTypes',
  async (payload, { rejectWithValue }) => {
    const { id, data } = payload || {};
    try {
      const url = `${UPDATE_VISUAL_TYPES}/${id}`;
      const response = await api.post(url, data);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data);
    }
  },
);

export const deleteVisualType = createAsyncThunk(
  'frametype/deleteVisualType',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.delete(`${DELETE_VISUAL_TYPES}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete Visual Type',
      );
    }
  },
);

export const fetchAllUser = createAsyncThunk(
  'frametype/fetchAllUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_USER);
      console.log(909, response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const deleteUser = createAsyncThunk(
  'frametype/deleteUser',
  async (id, { rejectWithValue }) => {
    try {
      console.log('hello delete user ', id);
      const response = await api.delete(`${DELETE_USER}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete User',
      );
    }
  },
);

export const updateUser = createAsyncThunk(
  'frametype/updateUser',
  async (payload, { rejectWithValue }) => {
    const { id, data } = payload || {};
    try {
      const url = `${UPDATE_USER}/${id}`;
      const response = await api.post(url, data);
      return response.data;
    } catch (error) {
      if (error.response?.data?.errors) {
        return rejectWithValue({
          errors: error.response.data.errors,
          message: error.response.data.message
        });
      }
      return rejectWithValue(error.response?.data);
    }
  },
);

export const fetchRitesSupUser = createAsyncThunk(
  'frametype/fetchRitesSupUser',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_RITES_SUP_USER);
      console.log(909, response);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
export const fetchAirBrakePoints = createAsyncThunk(
  'frametype/fetchAirBrakePoints',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_AIR_BRAKE_POINTS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
